import createIcon from '../../createIcon';

/**
 * @component @name MonetizationOn
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMy40MSAxOC4wOVYyMEgxMC43NFYxOC4wN0M5LjAzIDE3LjcxIDcuNTggMTYuNjEgNy40NyAxNC42N0g5LjQzQzkuNTMgMTUuNzIgMTAuMjUgMTYuNTQgMTIuMDggMTYuNTRDMTQuMDQgMTYuNTQgMTQuNDggMTUuNTYgMTQuNDggMTQuOTVDMTQuNDggMTQuMTIgMTQuMDQgMTMuMzQgMTEuODEgMTIuODFDOS4zMyAxMi4yMSA3LjYzIDExLjE5IDcuNjMgOS4xNEM3LjYzIDcuNDIgOS4wMiA2LjMgMTAuNzQgNS45M1Y0SDEzLjQxVjUuOTVDMTUuMjcgNi40IDE2LjIgNy44MSAxNi4yNiA5LjM0SDE0LjNDMTQuMjUgOC4yMyAxMy42NiA3LjQ3IDEyLjA4IDcuNDdDMTAuNTggNy40NyA5LjY4IDguMTUgOS42OCA5LjExQzkuNjggOS45NSAxMC4zMyAxMC41IDEyLjM1IDExLjAyQzE0LjM3IDExLjU0IDE2LjUzIDEyLjQxIDE2LjUzIDE0LjkzQzE2LjUyIDE2Ljc2IDE1LjE1IDE3Ljc2IDEzLjQxIDE4LjA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MonetizationOn = createIcon('MonetizationOn', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V20H10.74V18.07C9.03 17.71 7.58 16.61 7.47 14.67H9.43C9.53 15.72 10.25 16.54 12.08 16.54C14.04 16.54 14.48 15.56 14.48 14.95C14.48 14.12 14.04 13.34 11.81 12.81C9.33 12.21 7.63 11.19 7.63 9.14C7.63 7.42 9.02 6.3 10.74 5.93V4H13.41V5.95C15.27 6.4 16.2 7.81 16.26 9.34H14.3C14.25 8.23 13.66 7.47 12.08 7.47C10.58 7.47 9.68 8.15 9.68 9.11C9.68 9.95 10.33 10.5 12.35 11.02C14.37 11.54 16.53 12.41 16.53 14.93C16.52 16.76 15.15 17.76 13.41 18.09Z',
      key: '10y3n8',
    },
  ],
]);

export default MonetizationOn;
